import { render, staticRenderFns } from "./EditSectionButton.vue?vue&type=template&id=5c2cad08&"
import script from "./EditSectionButton.vue?vue&type=script&lang=ts&"
export * from "./EditSectionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports